<div class="grid field col-12">
    <p-button 
        class="col-12 md:col-2 ui-lg-2"
        (click)="addExpense()"
        label="Add Expense">
    </p-button>
</div>
<div class="grid field col-12">
    <p-table [value]="expenses" dataKey="id" editMode="row">
        <ng-template #header>
            <tr>
                <th>Description</th>
                <th>Cost/Factor</th>
                <th>Factor</th>
                <th style="width:8em"></th>
                <th style="width:8em"></th>
            </tr>
        </ng-template>
        <ng-template #body let-rowData let-editing="editing" let-ri="rowIndex">
            <tr [pEditableRow]="rowData">
                <td>
                    <p-cellEditor>
                        <ng-template #input>
                            <input pInputText type="text" [(ngModel)]="rowData.description" required [ngStyle]="{'width':'100%'}">
                        </ng-template>
                        <ng-template #output>
                            {{rowData.description}}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td>
                    <p-cellEditor>
                        <ng-template #input>
                            $ <input pInputText type="number" [(ngModel)]="rowData.costPerFactor" size="6" [ngStyle]="{'width':'100%'}" min="0">
                        </ng-template>
                        <ng-template #output>
                            $ {{rowData.costPerFactor}}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td>
                    <p-cellEditor>
                        <ng-template #input>
                            <p-select [options]="expenseCostFactor" [(ngModel)]="rowData.expenseCostFactorId" [style]="{'width':'100%'}"></p-select>
                        </ng-template>
                        <ng-template #output>
                            {{rowData.expenseCostFactorId}}
                        </ng-template>
                    </p-cellEditor>
                </td>
                <td style="text-align:center">
                    <button *ngIf="!editing" pButton type="button" pInitEditableRow class="ui-button-info" (click)="onRowEditInit(rowData)">
                        <i pButtonIcon class="pi pi-pencil"></i>
                    </button>
                    <button *ngIf="editing" pButton type="button" pSaveEditableRow class="ui-button-success" style="margin-right: .5em" (click)="onRowEditSave(rowData)">
                        <i pButtonIcon class="pi pi-check"></i>
                    </button>
                    <button *ngIf="editing" pButton type="button" pCancelEditableRow class="p-button-danger" (click)="onRowEditCancel(rowData, ri)">
                        <i pButtonIcon class="pi pi-times"></i>
                    </button>
                </td>
                <td>
                    <p-button icon="pi pi-trash" (click)="remove(rowData)"></p-button>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>